import { Button } from "@/components/ui/button";
import { Check, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import React from "react";

interface StickyEditBannerProps {
  isSticky: boolean;
  onSave: () => void;
  onCancel: () => void;
  children?: React.ReactNode;
  className?: string;
}

export const StickyEditBanner: React.FC<StickyEditBannerProps> = ({
  isSticky,
  onSave,
  onCancel,
  children,
  className = "",
}) => {
  const { t } = useTranslation();
  return (
    <div className={`sticky top-0 z-50 ${className}`} style={{marginTop: 0, paddingTop: 0}}>
      <div className="flex items-center gap-2 px-3 py-2 rounded-sm bg-blue-50 dark:bg-blue-950/50 border border-blue-200 dark:border-blue-800 text-blue-500 dark:text-blue-300 text-sm font-medium backdrop-blur-sm justify-between">
        <div className="flex items-center gap-2">
          <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13h3l8-8a2.828 2.828 0 10-4-4l-8 8v3zm-2 7h12" /></svg>
          {children ? children : t('common.editMode')}
        </div>
        <div className="flex gap-1.5">
          <Button size="sm" className="h-7 rounded-sm bg-blue-500 hover:bg-blue-500 text-white text-xs" onClick={onSave}>
            <Check className="w-3.5 h-3.5 mr-1" />
            {t('common.save', 'Save')}
          </Button>
          <Button size="sm" variant="ghost" className="h-7 rounded-sm text-xs text-blue-500 dark:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900" onClick={onCancel}>
            <X className="w-3.5 h-3.5 mr-1" />
            {t('common.cancel', 'Cancel')}
          </Button>
        </div>
      </div>
    </div>
  );
}; 